import { useApiQuery } from "@/api";
import { FinanceLabField, getFinanceLabMetrics } from "@/entities/FinanceLab";
import { getLastValue } from "@/utils/metrics/metricsUtils";
import { ExpandableMarkdown } from "../components/ExpandableMarkdown";
import { LabelLLM } from "../components/LabelLLM";
import { useAtomValue } from "jotai";
import { showDataSourcesAtom } from "../state";
import { SourceTag } from "../components/SourceTag";
import { MetricSource } from "@/features/Metrics/Metrics.types";

export function InvestmentRationale() {
    const { data: rationale } = useApiQuery(getFinanceLabMetrics, {
        params: {
            labels: [FinanceLabField.DEAL_INVESTMENT_RATIONALE],
        },
    });
    const showDataSources = useAtomValue(showDataSourcesAtom);

    return (
        <div>
            <div className="mb-2">
                <ExpandableMarkdown
                    text={
                        getLastValue(rationale?.[0]?.values)?.formattedValue ||
                        "-"
                    }
                    maxLength={1800}
                />
            </div>
            {showDataSources && (
                <SourceTag
                    source={MetricSource.FINANCE_LAB}
                    fieldName={FinanceLabField.DEAL_INVESTMENT_RATIONALE}
                />
            )}
            <LabelLLM />
        </div>
    );
}
